import { render, staticRenderFns } from "./ZvtDialog.vue?vue&type=template&id=aa59b2da&scoped=true"
import script from "./ZvtDialog.vue?vue&type=script&lang=js"
export * from "./ZvtDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa59b2da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa59b2da')) {
      api.createRecord('aa59b2da', component.options)
    } else {
      api.reload('aa59b2da', component.options)
    }
    module.hot.accept("./ZvtDialog.vue?vue&type=template&id=aa59b2da&scoped=true", function () {
      api.rerender('aa59b2da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/dialogs/ZvtDialog.vue"
export default component.exports